import { getCurrency } from 'domain/fuse/preferences/currency';
import { FORM_NAME } from './constants';
import { getFormattedSearchSummary } from './model';
import { categories } from './components/data/trucksCategories';

// import //Notifier
const getContactPerson = (location) => {
  if (!location) {
    return {
      phone: '',
      email: '',
      contact: '',
    };
  }
  const { phone, email, contact } = location;
  return {
    phone,
    email,
    contact,
  };
};
export const getSearchState = (state) => {
  try {
    return state.form[FORM_NAME];
  } catch (e) {
    console.error(e);
  }
};
export const getSearchValues = (state) => getSearchState(state).values;

export const getPickup = (state) => getSearchValues(state).pickup;
export const getSearchType = (state) => getSearchValues(state).type;

export const getDropoffs = (state) => getSearchValues(state).delivery.stops;
export const getShipper = (state) =>
  // Shipper id or the current profile
  getSearchValues(state).shipperId || state.app.auth.profile.profileId;
export const getSender = (state) => getContactPerson(getPickup(state));

export const getRecievers = (state) => getDropoffs(state).map((stop) => getContactPerson(stop));
export const getLoad = (state) => getDropoffs(state).reduce((allLoads, item) => {
  const { load = {} } = item;
  const { items = [] } = load;
  return [...allLoads, ...items];
}, []);
export const getDescription = (state) => getDropoffs(state).reduce((allDesc, item) => {
  allDesc.push(item.description);
  return allDesc;
}, []);

export const getEquipment = (state) => getSearchValues(state).equipment;

export const getShipmentValue = (state) => getSearchValues(state).shipmentValue;

export const getShipmentItemDescription = (state) => getSearchValues(state).shipmentDescription;
export const getShipmentItemUnitOfMeasure = (state) => getSearchValues(state).itemUnitOfMeasure;
export const getShipmentItemQuantity = (state) => getSearchValues(state).itemQuantity;

export const getEquipments = (state) => {
  const { equipment = null, load } = getSearchValues(state);

  if (!equipment) {
    return equipment;
  }

  const requiredTruck = categories
    .find((category) => category._id === equipment.type)
    .childs.find((child) => child._id === load[0].item);
  return {
    ...equipment,
    truckSize: requiredTruck.name,
    capacity: requiredTruck.weight,
  };
};

export const getQuotingOptions = (state) => ({
  type: getSearchType(state),
  equipment: getEquipments(state),
  load: getLoad(state),
  shipmentValue: getShipmentValue(state),
  accessorials: [],
  shipmentItemSummary: {
    description: getShipmentItemDescription(state),
    unitOfMeasure: getShipmentItemUnitOfMeasure(state),
    quantity: getShipmentItemQuantity(state),
  },
  description: getDescription(state),
});

export const getSearchSummary = (state) => {
  const sender = getSender(state);
  const recievers = getRecievers(state);
  const pickupState = getPickup(state);
  const dropoffs = getDropoffs(state);
  const currency = getCurrency(state);
  let summary = {};
  try {
    summary = getFormattedSearchSummary(
      getQuotingOptions(state),
      sender,
      recievers,
      pickupState,
      dropoffs,
      currency,
    );
  } catch (e) {
    summary = {};
    console.error(e);
  }
  return summary;
};
